export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 4a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2v-5.5h2V20h6.586L19 12.586V6h-6V4h6zm-4.586 16H19v-4.586L14.414 20z\" fill=\"#7B61FF\"/><path d=\"M11.06 2.162L8.473 5.784h1.773v2H7.53v.973h2.716v2H7.53v1.973h-2v-1.973H2.813v-2H5.53v-.973H2.813v-2h1.774L2 2.162 3.627 1l2.902 4.063L9.433 1l1.627 1.162z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};